export const LANZOU_DOWNLOAD_URL = 'https://wwbvc.lanzoup.com/b01d724y9c'
export const LANZOU_DOWNLOAD_PASSWORD = '1234'
export const LANZOU_DOWNLOAD_LABEL = `蓝奏云 密码${LANZOU_DOWNLOAD_PASSWORD}`
